"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterGroupTypeToJSON = exports.FilterGroupTypeFromJSONTyped = exports.FilterGroupTypeFromJSON = exports.FilterGroupType = void 0;
/**
 *
 * @export
 */
exports.FilterGroupType = {
    Or: 0,
    And: 1
};
function FilterGroupTypeFromJSON(json) {
    return FilterGroupTypeFromJSONTyped(json, false);
}
exports.FilterGroupTypeFromJSON = FilterGroupTypeFromJSON;
function FilterGroupTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.FilterGroupTypeFromJSONTyped = FilterGroupTypeFromJSONTyped;
function FilterGroupTypeToJSON(value) {
    return value;
}
exports.FilterGroupTypeToJSON = FilterGroupTypeToJSON;
